import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { SettingsLabelWithoutMargin } from 'components/organisms/module-settings/styles';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { HelperText01 } from 'ozone/atoms';
const Container = styled.div`
  display: flex;
`;
const Info = styled.div`
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-right: var(--layout-03);
`;
const Label = styled(SettingsLabelWithoutMargin)`
  padding: 0;
`;
const Description = styled(HelperText01)`
  padding: var(--layout-01) var(--layout-01) var(--layout-01) 0;
  color: ${({ $isNew })=>$isNew ? 'var(--gray-70)' : undefined};
`;
const Control = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: 60%;

  & > * {
    margin-bottom: var(--spacing-05);

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
export const SettingsControlPanel = ({ label, descriptions = [], children, align, datacy })=>{
    const isNew = useAntdRlUISwitcher();
    return /*#__PURE__*/ _jsxs(Container, {
        style: align ? {
            alignItems: 'center'
        } : {},
        children: [
            /*#__PURE__*/ _jsxs(Info, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        children: label
                    }),
                    descriptions.map((x)=>/*#__PURE__*/ _jsx(Description, {
                            $isNew: isNew,
                            children: x
                        }, x))
                ]
            }),
            /*#__PURE__*/ _jsx(Control, {
                "data-cy": datacy,
                children: children
            })
        ]
    });
};
